import { getParentOfType, types } from 'mobx-state-tree';
import Module from './Module';
import Topic from './Topic';

const LearningResource = types
  .model('LearningResource', {
    id: types.maybe(types.string),
    instructions: types.string,
    embedLink: types.string,
    index: types.number,
  })
  .actions((self) => ({
    setInfo(resource) {
      for (let field in resource) {
        self[field] = resource[field];
      }
    },
  }))
  .views((self) => ({
    getParentModule() {
      return getParentOfType(self, Module);
    },
    getParentTopic() {
      return getParentOfType(self, Topic);
    },
  }));

export default LearningResource;
